import getColor from "@/utils/get-color.utils"
import {
  Risk,
  // RISK_STATUS_MAP,
  RiskLevelId,
  RiskResidualItem,
  RiskScaleItem
  // RiskStatus,
  // RiskStatusId
} from "./risk.types"
import { t } from "i18next"
import { groupBy } from "lodash"

function getSignature(r: Risk): string {
  return JSON.stringify({
    attributes: r.attributes,
    frequency: r.frequency,
    prevention: r.prevention,
    severity: r.severity
  })
}

export function buildRiskAssociated(risks: Risk[]): Risk[] {
  // On groupe les risks par un identifiant unique basé sur :
  // - attributes (JSON.stringify)
  // - frequency
  // - prevention
  // - severity
  const grouped = groupBy(risks, getSignature)

  // Build associations
  return Object.values(grouped).map<Risk>((group) => {
    const [first, ...others] = group
    return {
      ...first,
      associatedRisks: group.length > 1 ? others : []
    }
  })
}

/**
 * Match value with the sacle
 */
export function getScaleMatch(score: number, scales: RiskResidualItem[]): { item: RiskResidualItem; index: number } {
  const len = scales.length

  if (score < scales[0].min) return { item: scales[0], index: 0 }
  if (score > scales[len - 1].max) return { item: scales[len - 1], index: len - 1 }

  for (let i = 0; i < len; i++) {
    const s = scales[i]
    if (score >= s.min && score <= s.max) {
      return { item: s, index: i }
    }
  }

  return { item: scales[0], index: 0 } // sécurité
}

export function getScaleFormatted(score: number, residualRiskScale: RiskResidualItem[]) {
  const { item: match, index } = getScaleMatch(score, residualRiskScale)

  return {
    levelId: (match?.color as RiskLevelId) ?? "grey",
    label: match?.label ?? t("risk_value_label_unknown"),
    color: getColor(match?.color ?? "grey"),
    score,
    index // Used for sorting
  }
}

/**
 * Get status
 */
// export function getStatus(risk: Risk): RiskStatus {
//   const statusId = getStatusId(risk)
//   return RISK_STATUS_MAP[statusId]
// }

// export function getStatusId(risk: Risk): RiskStatusId {
//   if (risk.dateArchived) {
//     return "archived"
//   } else {
//     return "validated"
//   }
// }

/**
 * Évalue un risque en fonction de la config (account.options.riskScales)
 */
export const getValueInitial = (frequency: number, severity: number, residualRiskScale) => {
  const score = frequency * severity
  return getScaleFormatted(score, residualRiskScale)
}

/**
 * Évalue un risque en fonction de la config (account.options.riskScales)
 */
export const getValueResidual = (valueInitial: number, prevention: number, residualRiskScale) => {
  const score = valueInitial / Math.max(1, prevention)
  return getScaleFormatted(score, residualRiskScale)
}

//Update value according the scale
export function updateEvaluation(value: number, scale: RiskScaleItem[]) {
  const closest = scale.reduce((prev, curr) =>
    Math.abs(curr.value - value) < Math.abs(prev.value - value) ? curr : prev
  )

  return {
    value,
    label: closest.label
  }
}
